module.exports = __webpack_public_path__ + "img/config1.6afa3796.png";